"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      borderBottom: "1px solid " + theme.palette.divider,
      boxShadow: "none"
    }
  };
};

exports.styles = styles;